import React, { Component, Fragment } from 'react';

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  LabelList
} from 'recharts';

import { Error, selectFormat } from './../Utils/Utils.js';

const COLORS = [
  '#f4f4f4',
  '#FAA461'
];

// class CustomToolTip extends Component {

//   showLabels = (payload) => {
//     let labels = Object.keys(payload).map(function (key) {
//       return <p className="label" key={key}>
//         <span className="value">{selectFormat('numeric', payload[key].value)}</span>
//       </p>
//     });

//     return labels;
//   }

//   render() {
//     const { active } = this.props;

//     if (active) {
//       const { payload } = this.props;
//       if (payload && payload.length > 0) {
//         return (
//           <div className="custom-tooltip">
//             {this.showLabels(payload)}
//           </div>
//         );
//       }
//     }

//     return null;
//   }
// }

class SubscriberMakeup extends Component {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return (
        <Error minHeight={360} />
      );
    }
    
    return (

      <Fragment>
        <ResponsiveContainer height={290} width="100%">
          <BarChart width={150} height={100} data={data.bar_chart} margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: 0
          }}>
            {/* <Tooltip cursor={{ fill: "#eee", opacity:.5 }} content={< CustomToolTip />} cursor={{
              fill: '#ccc',
              fillOpacity: 0.3
            }} /> */}
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
              </linearGradient>
            </defs>
            <Bar dataKey="value" fillOpacity={1} fill="url(#colorUv)">
              <LabelList dataKey="value" position="top" formatter={(value) => (selectFormat('numeric', value))} />
            </Bar>
            <XAxis dataKey="label" axisLine={false} tickLine={false} tick={{
              strokeWidth: 0,
              fill: '#25263F'
            }} />
          </BarChart>
        </ResponsiveContainer>


        <div className="row">
          <div className="col-6 col-sm-3 d-flex flex-column align-items-center">
            <h6 className="widget__metric-label">Power Watchers</h6>
            <PieChart height={70} width={70}>
              <Pie dataKey="value" data={data.pie_charts.power_watchers} outerRadius="100%" innerRadius="70%">
                {
                  data.pie_charts.power_watchers.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                  ))
                }
              </Pie>
              <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__small">
                {selectFormat('percentage', data.pie_charts.power_watchers[1].value / 100, '%')}
              </text>
            </PieChart>
          </div>

          <div className="col-6 col-sm-3 d-flex flex-column align-items-center">
            <h6 className="widget__metric-label">Regular Watchers</h6>
            <PieChart height={70} width={70}>
              <Pie dataKey="value" data={data.pie_charts.regular_watchers} outerRadius="100%" innerRadius="70%">
                {
                  data.pie_charts.regular_watchers.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                  ))
                }
              </Pie>
              <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__small">
                {selectFormat('percentage', data.pie_charts.regular_watchers[1].value / 100, '%')}
              </text>
            </PieChart>
          </div>

          <div className="col-6 col-sm-3 d-flex flex-column align-items-center">
            <h6 className="widget__metric-label">Occasional Watchers</h6>
            <PieChart height={70} width={70}>
              <Pie dataKey="value" data={data.pie_charts.occasional_watchers} outerRadius="100%" innerRadius="70%">
                {
                  data.pie_charts.occasional_watchers.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                  ))
                }
              </Pie>
              <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__small">
                {selectFormat('percentage', data.pie_charts.occasional_watchers[1].value / 100, '%')}
              </text>
            </PieChart>
          </div>

          <div className="col-6 col-sm-3 d-flex flex-column align-items-center">
            <h6 className="widget__metric-label">Never Watchers</h6>
            <PieChart height={70} width={70}>
              <Pie dataKey="value" data={data.pie_charts.never_watchers} outerRadius="100%" innerRadius="70%">
                {
                  data.pie_charts.never_watchers.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                  ))
                }
              </Pie>
              <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__small">
                {selectFormat('percentage', data.pie_charts.never_watchers[1].value / 100, '%')}
              </text>
            </PieChart>
          </div>

        </div>
      </Fragment>

    );
  }
}

export default SubscriberMakeup
